export function setupQuery() {
  const queryObj = {} as Record<string, any>;
  const queryStr = location.search.slice(1);

  if (!queryStr) {
    window.query = {};
    return;
  }

  queryStr.split('&').forEach((item) => {
    const [key, val] = item.split('=');
    queryObj[key] = decodeURIComponent(val);
    localStorage.setItem(key, val);
  });

  window.query = queryObj;
}
